module.exports = __webpack_public_path__ + "static/aha-moment-812ca09e7e83fbd948b7d861da5f963f.png";